import appVersion from '@map/state/appVersion';
import dataState from '@map/state/dataState';
import experienceSkills from '@map/state/experienceSkills';
import experiences from '@map/state/experiences';
import help from '@map/state/help';
import notifications from '@map/state/notifications';
import profile from '@map/state/profile';
import storeService, { STORE_LOADED } from '@map/state/storeService';
import user, { USER_FETCHED, USER_LOGGED_OUT } from '@map/state/user';
import userDocuments from '@map/state/userDocuments';
import { combineReducers, Reducer } from 'redux';

const appReducer = combineReducers({
  user,
  profile,
  storeService,
  appVersion,
  notifications,
  dataState,
  userDocuments,
  help,
  experienceSkills,
  experiences,
});

type State = typeof appReducer extends Reducer<infer State, any, any> ? State : never;
type Action = typeof appReducer extends Reducer<any, infer Action, any> ? Action : never;

// preserve some store values after logout
const resetState = (state: State) => {
  const { storeService, user } = state;
  return {
    storeService,
    user: { locale: user.locale },
  } as State;
};

const rootReducer = (state: State | undefined, action: Action) => {
  if (!state) {
    return appReducer(state, action);
  }
  if (action.type === STORE_LOADED) {
    return appReducer(action.data as State, action);
  }
  const clearState =
    action.type === USER_LOGGED_OUT ||
    (action.type === USER_FETCHED && state.user.id && !action.data.id);
  return appReducer(clearState ? resetState(state) : state, action);
};

export default rootReducer;
